/* global SideDrawer, debounce, initLazyImages */

if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);

      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');

      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        // this.activeFilters = this.querySelector('.facets__active-filters');
        // this.activeFiltersList = this.querySelector('.active-filters');
        // this.activeFiltersHeader = this.querySelector('.active-filters-header');
        // this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.mobileSortByOptions = this.querySelectorAll('.js-drawer-sort-by');
        this.desktopSortBy = document.querySelector('.products-toolbar__sort');
      }

      this.handleBreakpointChange();
      this.addListeners();
    }

    addListeners() {
      if (this.filteringEnabled) {
        // this.breakpointChangeHandler = this.breakpointChangeHandler
        //   || this.handleBreakpointChange.bind(this);
        // this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
        // this.filters.addEventListener('input', debounce(this.handleFilterChange.bind(this), 500));
        // this.activeFilters.addEventListener('click', this.handleActiveFiltersClick.bind(this));
        // window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
        this.filters.addEventListener('change', this.handleFilterChange.bind(this));
      }

      // FIX: Added '&& this.desktopSortBy' check to prevent crash if element is missing
      if (this.sortingEnabled && this.desktopSortBy) {
        this.desktopSortBy.addEventListener('change', this.handleFilterChange.bind(this));
      }

      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }

    /**
     * Handles viewport breakpoint changes.
     */
    handleBreakpointChange() {
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      this.removeAttribute('aria-modal');
      this.removeAttribute('role');
    }

    /**
     * Handles 'input' events on the filters and 'change' events on the sort by dropdown.
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {

      if (evt.target.closest('.main-products-grid__filters')) {
        
        // Notify the toolbar script to update UI
        const toolbar = document.querySelector('products-toolbar');
        if (toolbar && toolbar.updateDrawerUI) {
          toolbar.updateDrawerUI();
        }
        
        return; // STOP execution. Do not fetch. Do not update URL.
      }

      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      if (this.sortingEnabled) {
        let currentSortBy = searchParams.get('sort_by');

        // Keep the mobile facets form sync'd with the desktop sort by dropdown
        if (evt.target.tagName === 'CUSTOM-SELECT') {
          if (this.mobileSortByOptions) {
             this.mobileSortByOptions.forEach((option) => {
              option.checked = option.value === evt.detail.selectedValue;
              currentSortBy = evt.detail.selectedValue;
            });
          }
        }

        // Set the 'sort_by' parameter.
        searchParams.set('sort_by', currentSortBy);
      }

      // Get empty parameters.
      searchParams.forEach((value, key) => {
        if (!value) emptyParams.push(key);
      });

      // Remove empty parameters.
      emptyParams.forEach((key) => {
        searchParams.delete(key);
      });

      this.applyFilters(searchParams.toString(), evt);
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;

      // Filter 'clear' button clicked.
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }

      // Filter 'show more' button clicked.
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });
      }
    }

    /**
     * Handles 'click' events on the active filters.
     * @param {object} evt - Event object.
     */
    handleActiveFiltersClick(evt) {
      if (evt.target.tagName !== 'A') return;
      evt.preventDefault();
      this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = '';

        if (evt.state && evt.state.searchParams) {
          ({ searchParams } = evt.state);
        }

        this.applyFilters(searchParams, null, false);
      }
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {object} evt - Event object.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     */
    async applyFilters(searchParams, evt, updateUrl = true) {
      const customPagination = document.querySelector('custom-pagination');
      if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

      this.results.classList.add('is-loading');

      // Disable "Show X results" button until submission is complete.
      const closeBtn = this.querySelector('.js-close-drawer-mob');
      if (closeBtn) {
        closeBtn.ariaDisabled = 'true';
        closeBtn.classList.add('is-loading');
      }

      // Fetch filtered products markup.
      const response = await fetch(`${window.location.pathname}?${searchParams}`);
      if (response.ok) {
         const tmpl = document.createElement('template');
         tmpl.innerHTML = await response.text();
         this.results.innerHTML = tmpl.content.getElementById('filter-results').innerHTML;
         if (updateUrl) window.history.pushState({ searchParams }, '', `${window.location.pathname}?${searchParams}`);
       }
    }

    /**
     * Updates the filters with the fetched data.
     * @param {string} html - HTML of the fetched document.
     * @param {object} evt - Event object.
     */
    updateFilters(html, evt) {
      const filters = document.querySelectorAll('.filter');
      
      filters.forEach((filter) => {
        const { index } = filter.dataset;
        const fetchedFilter = html.querySelector(`.filter[data-index="${index}"]`);

        if (filter.dataset.type !== 'sort') {
          if (filter.dataset.type === 'price_range') {
            FacetFilters.updateFilter(filter, fetchedFilter, false);

            if (!evt || evt.target.tagName !== 'INPUT') {
              filter.querySelectorAll('input').forEach((input) => {
                const fetchedInput = html.getElementById(input.id);
                if(fetchedInput) input.value = fetchedInput.value;
              });
            }
          } else if (evt && evt.target.tagName === 'INPUT') {
            const changedFilter = evt.target.closest('.filter');

            if (changedFilter && changedFilter.dataset) {
              FacetFilters.updateFilter(
                filter,
                fetchedFilter,
                filter.dataset.index !== changedFilter.dataset.index
              );
            }
          } else {
            FacetFilters.updateFilter(filter, fetchedFilter, true);
          }
        }
      });

      // Update active filters.
      this.updateActiveFilters(html);

      // Update '[x] results' button (mobile only).
      const footerEl = html.querySelector('.facets__footer');
      if(this.footer && footerEl) this.footer.innerHTML = footerEl.innerHTML;
    }

    /**
     * Updates a filter.
     * @param {Element} filter - Filter element.
     * @param {Element} fetchedFilter - Fetched filter element.
     * @param {boolean} updateAll - Update all filter markup or just toggle/header.
     */
    static updateFilter(filter, fetchedFilter, updateAll) {
      if (fetchedFilter) {
        filter.hidden = false;
        if (updateAll) {
          filter.innerHTML = fetchedFilter.innerHTML;
        } else {
          // Update toggle and header only.
          const existingToggle = filter.querySelector('.filter__toggle');
          const newToggle = fetchedFilter.querySelector('.filter__toggle');
          if(existingToggle && newToggle) {
             filter.replaceChild(newToggle, existingToggle);
          }
          
          const existingHeader = filter.querySelector('.filter__header');
          const newHeader = fetchedFilter.querySelector('.filter__header');
          if(existingHeader && newHeader) {
              existingHeader.innerHTML = newHeader.innerHTML;
          }
        }
      } else {
        filter.hidden = true;
      }
    }

    /**
     * Updates the active filters.
     * @param {string} html - HTML of the fetched page.
     */
    updateActiveFilters(html) {
      const activeFiltersList = html.querySelector('.active-filters');
      const activeFiltersHeader = html.querySelector('.active-filters-header');

      if(this.activeFiltersList && activeFiltersList) {
          this.activeFiltersList.innerHTML = activeFiltersList.innerHTML;
      }
      if(this.activeFiltersHeader && activeFiltersHeader) {
          this.activeFiltersHeader.innerHTML = activeFiltersHeader.innerHTML;
      }
      if(this.activeFilters) {
          this.activeFilters.hidden = !this.activeFiltersList.querySelector('.active-filter');
      }
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);
}